export const DATA = [
  {
    // Red stuff
    A: 'Apple',
    B: 'Blood Orange',
    C: 'Cranberry',
    D: 'Dragonfruit',
    E: 'Early Girl Tomato',
    F: 'Fig',
    G: 'Goji Berry',
  },
  {
    // Green stuff
    A: 'Avocado',
    B: 'Broccoli',
    C: 'Cucumber',
    D: 'Dill',
    E: 'Edamame',
    F: 'Fennel',
    G: 'Green Tea',
  },
  {
    // Yellow stuff
    A: 'A Squash',
    B: 'Banana',
    C: 'Corn',
    D: 'Durian',
    E: 'Egg Yolk',
    F: 'French Fries',
    G: 'Ginger',
  },
];
